// Page-specific styles for the SafeModePage preset cards and the readable
// summary block. Shared form atoms (label, button, message, etc.) live in
// ../../components/onboarding/onboarding-form.styles.ts. Frame styles live
// in onboarding-shell.styles.ts.

import type { CSSProperties } from "react";

export const presetGroup: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "var(--sz-space-3)",
};

const basePresetRow: CSSProperties = {
  display: "flex",
  alignItems: "flex-start",
  gap: "var(--sz-space-3)",
  padding: "16px 18px",
  background: "var(--sz-bg-surface-2)",
  border: "1px solid var(--sz-border-default)",
  borderRadius: "var(--sz-radius-md)",
  cursor: "pointer",
  transition: "border-color var(--sz-duration-fast), background var(--sz-duration-fast)",
};

export const presetRow: CSSProperties = basePresetRow;

export const presetRowSelected: CSSProperties = {
  ...basePresetRow,
  borderColor: "var(--sz-amber)",
  background: "var(--sz-amber-glow)",
};

export const presetInput: CSSProperties = {
  accentColor: "var(--sz-amber)",
  width: "16px",
  height: "16px",
  marginTop: "3px",
};

export const presetBody: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  flex: 1,
};

export const presetTitle: CSSProperties = {
  fontFamily: "var(--sz-font-body)",
  fontSize: "var(--sz-body-md)",
  color: "var(--sz-text-primary)",
  fontWeight: 500,
};

export const presetCaption: CSSProperties = {
  fontFamily: "var(--sz-font-body)",
  fontSize: "var(--sz-body-sm)",
  color: "var(--sz-text-secondary)",
  lineHeight: 1.55,
};

export const presetMeta: CSSProperties = {
  fontFamily: "var(--sz-font-mono)",
  fontSize: "var(--sz-mono-sm)",
  letterSpacing: "1.5px",
  color: "var(--sz-text-muted)",
  marginTop: "4px",
};

export const summaryCard: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "var(--sz-space-3)",
  padding: "20px 22px",
  background: "var(--sz-bg-surface-2)",
  border: "1px solid var(--sz-border-default)",
  borderRadius: "var(--sz-radius-md)",
};

export const summaryHeading: CSSProperties = {
  fontFamily: "var(--sz-font-mono)",
  fontSize: "var(--sz-mono-xs)",
  letterSpacing: "2px",
  textTransform: "uppercase",
  color: "var(--sz-text-muted)",
};

export const summaryRow: CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  gap: "var(--sz-space-3)",
  alignItems: "baseline",
  borderBottom: "1px solid var(--sz-border-subtle)",
  paddingBottom: "8px",
};

export const summaryRowLast: CSSProperties = {
  ...summaryRow,
  borderBottom: "none",
  paddingBottom: 0,
};

export const summaryLabel: CSSProperties = {
  fontFamily: "var(--sz-font-body)",
  fontSize: "var(--sz-body-sm)",
  color: "var(--sz-text-secondary)",
};

export const summaryValue: CSSProperties = {
  fontFamily: "var(--sz-font-mono)",
  fontSize: "var(--sz-mono-md)",
  letterSpacing: "1.5px",
  color: "var(--sz-text-primary)",
};
